<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar" (mouseenter)="mouseHover($event)" (mouseleave)="mouseOut($event)">
    <!-- Menu -->
    <div class="menu">
      <ul class="list"
        [ngStyle]="{'position' : 'relative', 'max-height' : listMaxHeight+'px', 'max-width' : listMaxWidth+'px'}"
        >
        <li class="sidebar-user-panel">
          <div class="user-panel">
            <div class=" image">
              <img src="assets/images/user/user.png" class="img-circle user-img-circle" alt="User Image" />
            </div>
          </div>
          <div class="profile-usertitle">
            <div class="sidebar-userpic-name">{{userFullName}} </div>
            <div class="profile-usertitle-job ">{{userType}} </div>
          </div>
        </li>
        <!-- Top Most level menu -->
        @for (sidebarItem of sidebarItems; track sidebarItem) {
          <li [class.active]="level1Menu === sidebarItem.moduleName && sidebarItem.submenu.length !== 0"
            [routerLinkActive]="sidebarItem.submenu.length !== 0 ? '' : 'active'">
            @if (sidebarItem.groupTitle === true) {
              <div class="header">{{sidebarItem.title | translate}}</div>
            }
            @if (!sidebarItem.groupTitle;) {
              <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null"
                [ngClass]="[sidebarItem.class]" (click)="callLevel1Toggle($event, sidebarItem.moduleName)" class="menu-top">
                <i [ngClass]="[sidebarItem.iconType]">{{sidebarItem.icon}}</i>
                <span class="hide-menu">{{sidebarItem.title | translate}}
                </span>
                @if (sidebarItem.badge !== '' ) {
                  <span [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
                }
              </a>
            }
            <!-- First level menu -->
            @if (sidebarItem.submenu.length > 0) {
              <ul class="ml-menu">
                @for (sidebarSubItem of sidebarItem.submenu; track sidebarSubItem) {
                  <li [ngClass]="level2Menu === sidebarSubItem.moduleName? 'activeSub':''"
                    [routerLinkActive]="sidebarSubItem.submenu.length > 0 ? '' : 'active'">
                    <a [routerLink]="sidebarSubItem.submenu.length > 0 ? null : [sidebarSubItem.path]"
                      (click)="callLevel2Toggle($event,sidebarSubItem.moduleName)" [ngClass]="[sidebarSubItem.class]">
                      {{sidebarSubItem.title | translate}}
                    </a>
                    <!-- Second level menu -->
                    @if (sidebarSubItem.submenu.length > 0) {
                      <ul class="ml-menu-2">
                        @for (sidebarSubsubItem of sidebarSubItem.submenu; track sidebarSubsubItem) {
                          <li
                            [ngClass]="level3Menu === sidebarSubsubItem.moduleName? 'activeSubSub':''"
                            [routerLinkActive]="sidebarSubsubItem.submenu.length > 0 ? '' : 'active'">
                            <a [routerLink]="sidebarSubsubItem.submenu.length > 0 ? null : [sidebarSubsubItem.path]"
                              (click)="callLevel3Toggle($event,sidebarSubsubItem.moduleName)"
                              [ngClass]="[sidebarSubsubItem.class]">
                              {{sidebarSubsubItem.title | translate}}
                            </a>
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
        <li>
          <a class="" (click)="logout()" class="menu-top">
            <i class="material-icons-two-tone">power_settings_new</i>
            <span class="hide-menu">Salir
            </span>
          </a>
        </li>
        <li class="sidebar-user-panel">
          <div class="user-panel">
            <div class="imagems">
              <a href="http://www.medisystem.com.mx" target="_blank"> <img src="assets/images/medisystem.jpg" class="img-circle user-img-circle" alt="MediSystem Software" /></a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>
